import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-task-trans",
  "use": "icon-ib-task-trans-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib-task-trans\"><path d=\"M512 309.333333a32 32 0 0 1 32 32v449.962667a32 32 0 0 1-64 0V341.333333a32 32 0 0 1 32-32z\" p-id=\"8009\" /><path d=\"M298.965333 341.333333a32 32 0 0 1 32-32h362.026667a32 32 0 0 1 0 64H330.965333a32 32 0 0 1-32-32z\" p-id=\"8010\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol